import './scripts/main';
import './scripts/ab-main.js';
import './styles/main';

import '../_common/images/homepage-support-icon.svg';
import '../_common/images/homepage-verified-icon.svg';
import '../_common/images/homepage-step1.svg';
import '../_common/images/homepage-step2.svg';
import '../_common/images/homepage-step3.svg';
import '../_common/images/phone-hero-bg.png';
import './images/runner.svg';



// WEBPACK FOOTER //
// ./get-quotes/index.js